// @ts-nocheck
import { create } from 'zustand';
import { useWorkspaceStore, openSettingsTab } from './workspace';

export type SettingsSection =
  | 'general'
  | 'notifications'
  | 'alerts'
  | 'blackouts'
  | 'correlation'
  | 'collector'
  | 'queryStore'
  | 'health'
  | 'retention'
  | 'users'
  | 'infra'
  | 'ai'
  | 'vpn';

type SettingsModalState = {
  open: boolean;
  section: SettingsSection;
  openSettings: (section?: SettingsSection) => void;
  closeSettings: () => void;
  setSection: (section: SettingsSection) => void;
};

export const useSettingsModalStore = create<SettingsModalState>((set) => ({
  open: false,
  section: 'general',
  openSettings: (section = 'general') => {
    set({ open: true, section });
    openSettingsTab();
  },
  closeSettings: () => {
    set({ open: false });
    const st = useWorkspaceStore.getState();
    const t = st.tabs.find((x) => x.type === 'settings');
    if (t) st.closeTab(t.id);
  },
  setSection: (section) => set({ section }),
}));

export const UI_PREFS_KEY = 'dbtoolbox_ui_prefs';

export function readUiPrefs() {
  try {
    return JSON.parse(localStorage.getItem(UI_PREFS_KEY) || '{}');
  } catch {
    return {};
  }
}

export function writeUiPrefs(patch: Record<string, unknown>) {
  const cur = readUiPrefs();
  localStorage.setItem(UI_PREFS_KEY, JSON.stringify({ ...cur, ...patch }));
}
